import API from './api';
import { FLUXOGRAM_NODE_CLASS } from './config/markup';

export default class Markup {
  constructor(graph, style) {
    this.api = new API(graph, style);
  }

  build(holderNode) {
    this.buildHtml(holderNode);

    const api = this.buildFluxogram(holderNode);

    return { api };
  }

  buildHtml(holderNode) {
    const fluxogramNode = document.createElement('div');

    fluxogramNode.className = FLUXOGRAM_NODE_CLASS;

    fluxogramNode.appendChild(document.createTextNode(this.api.getCode()));

    holderNode.innerHTML = '';
    holderNode.appendChild(fluxogramNode);

    return this;
  }

  buildFluxogram(holderNode) {
    if (!this.api.sintaxIsValid()) {
      return null;
    }

    return this.api.build(holderNode);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/markup.js
 **/